var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',{attrs:{"id":"common-task-list"}},[_c('Main',{attrs:{"encrypt-config":_vm.encryptConfig,"is-dark":_vm.isDark,"is-hide":_vm.isHide,"market":_vm.market}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }